import { render, staticRenderFns } from "./VersionManage.vue?vue&type=template&id=0ead2aaa&scoped=true&"
import script from "./VersionManage.vue?vue&type=script&lang=js&"
export * from "./VersionManage.vue?vue&type=script&lang=js&"
import style0 from "./VersionManage.vue?vue&type=style&index=0&id=0ead2aaa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead2aaa",
  null
  
)

export default component.exports